
namespace GeniuzPOS.QRreport {

    @Serenity.Decorators.registerClass()
    export class QDayDataGrid extends Serenity.EntityGrid<QDayDataRow, any> {
        protected getColumnsKey() { return QDayDataColumns.columnsKey; }
        protected getDialogType() { return QDayDataDialog; }
        protected getIdProperty() { return QDayDataRow.idProperty; }
        protected getInsertPermission() { return QDayDataRow.insertPermission; }
        protected getLocalTextPrefix() { return QDayDataRow.localTextPrefix; }
        protected getService() { return QDayDataService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}